import ReactCalendar from 'react-calendar';

import moment from 'moment';

import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';
import Popover from 'components/shared/Popovers/Popover/Popover';

const CalendarPopover = (props) => {
  const {
    value,
    onChange,
    isRange = false,
    format = 'MM/DD/YYYY',
    className,
    icon = 'calendar-mono',
    textClassName
  } = props;

  const formattedValue = isRange
    ? value.map((date) => moment(date).format(format)).join('-')
    : moment(value).format(format);

  const CustomButton = (
    <div className={cn('flex items-center gap-1', className)}>
      {icon && <Icon icon={icon} />}
      <span className={cn('text-sm text-neutral-900', textClassName)}>{formattedValue}</span>
    </div>
  );

  return (
    <Popover
      isFixed
      className="flex items-center"
      panelClassName="p-0"
      customButtonTrigger={CustomButton}>
      <ReactCalendar
        onChange={onChange}
        value={value}
        className={className}
        selectRange={isRange}
      />
    </Popover>
  );
};

export default CalendarPopover;
